import theme from '@/configs/theme';
import customComponents from '@/modules/global/components/dynamic-form/custom-components/index';
import TaqadhiUI from '@moj/taqadhi-ui';
import axios from 'axios';
import Vue from 'vue';

import '@moj/taqadhi-ui/dist/taqadhi-ui.css';

Vue.use(TaqadhiUI, {
  theme,
  axios,
  customComponents: customComponents.map(c => c.component),
});
